import { useIntl } from "react-intl";
import { WmButton } from "@watermarkinsights/ripple-react";
import { buildSvgIconHref } from "../ai-chat-message-utils";

interface AssistantMessageActionsProps {
  isCopied: boolean;
  onCopyResponseText: () => void;
}

export const AssistantMessageActions = ({
  isCopied,
  onCopyResponseText,
}: AssistantMessageActionsProps) => {
  const intl = useIntl();

  return (
    <div className="tcw-response-actions">
      <div className="tcw-action-group">
        <WmButton
          button-type="navigational"
          icon={buildSvgIconHref("copy")}
          className="tcw-action-btn"
          tooltip={intl.formatMessage({ id: "app.toolboxChat.action.copyResponse" })}
          onClick={onCopyResponseText}
        />
        {isCopied && (
          <span className="tcw-copied" role="status">
            {intl.formatMessage({ id: "app.toolboxChat.action.copied" })}
          </span>
        )}
      </div>
    </div>
  );
};
